import MuiCardContent, { CardContentProps as MuiCardContentProps } from '@mui/material/CardContent';

export type CardContentProps = MuiCardContentProps;

export const CardContent = (props: CardContentProps) => {
  return <MuiCardContent {...props} />;
};
